import { getClonedObject, sort, triggerFn } from "@wms/app/core";
import { pull, replace, forEach, invert, find } from "lodash";
import { DataModelDesignManagerService } from "@wms/app/services";
import { AppInjector } from "@wms/app/variables";

export const DEMO_PROVIDER = {
  id: 'DEMO',
  key: 'LABEL_DEMO',
  file: 'demo.html',
  value: 'Demo'
};
export const DB_PROVIDER = {
  id: 'DATABASE',
  key: 'LABEL_DATABASE',
  file: 'database.html',
  value: 'Database'
};
export const LDAP_PROVIDER = {
  id: 'LDAP',
  key: 'LABEL_LDAP',
  file: 'ldap.html',
  value: 'LDAP'
};
export const AD_PROVIDER = {
  id: 'AD',
  key: 'LABEL_ACTIVE_DIRECTORY',
  file: 'activeDirectory.html',
  value: 'AD'
};
export const CAS_PROVIDER = {
  id: 'CAS',
  key: 'LABEL_CAS',
  file: 'cas.html',
  value: 'CAS'
};
export const SAML_PROVIDER = {
  id: 'SAML',
  key: 'LABEL_SAML',
  file: 'saml.html',
  value: 'SAML'
};
export const OPENID_PROVIDER = {
  id: 'OPENID',
  key: 'LABEL_OPENID',
  file: 'openId.html',
  value: 'OpenId'
};
export const CUSTOM_PROVIDER = {
  id: 'CUSTOM',
  key: 'LABEL_CUSTOM',
  file: 'custom.html',
  value: 'Custom'
};
export const JWS_PROVIDER = {
  id: 'JWS',
  key: 'LABEL_JWS',
  file: 'jws.html',
  value: 'JWS'
};
export const OPAQUE_TOKEN_PROVIDER = {
  id: 'OPAQUE_TOKEN',
  key: 'LABEL_OPAQUE_TOKEN',
  file: 'OPAQUE_TOKEN.html',
  value: 'OPAQUE_TOKEN'
};

export const POLICY_OPTIONS = {
  IMPORT: 'IMPORT',
  MANUAL: 'MANUAL'
};
export const WHITE_LIST = 'WHITE LIST';
export const LOGIN_OPTIONS = {
  PAGE: 'PAGE',
  DIALOG: 'DIALOG',
  SSO: 'SSO'
};
export const SSO_PROVIDERS = ['SAML', 'CAS', 'OPENID'];

export const ROLE_PROVIDERS_SAML = ['SAML', 'Database'];
export const JKS_FILE_PATH = '../project/services/securityService/src/saml/';
export const KEY_STORE_NAME  = 'key-store.jks';
export const KEY_STORE_OPTIONS = ['AUTO GENERATE', 'IMPORT'];
export const METADATA_OPTIONS = [{
  'label': 'URL',
  'value': 'URL'
}, {
  'label': 'FILE',
  'value': 'FILE'
}];

//Preparing the list of options for landing pages
export function setLandingPageOptions(security: any) {
  let pages: any = getClonedObject(security.pagesList);
  //Skip login page in post landing pages since, it is not a right scenario where login page and post landing page are same
  security.landingPagesList = pull(pages, security.login.pageName, security.login.sessionTimeout.pageName);
}

// Replace special characters with "_"
export function getValidFileName(fileName: string) {
  return replace(fileName, /[^a-zA-Z0-9.-]/g, "_");
}

//to set the entities of selected dataModel
export function setEntities(projectId: any, selectedDatabase: any, scopeObj: any, onSuccess?: any) {
  const dataModelDesignManager = AppInjector.get(DataModelDesignManagerService);

  dataModelDesignManager.getDataModel(projectId, selectedDatabase, false, (datamodel: any) => {
    let tables = datamodel.tables,
      entities: any = [];
    // TODO
    // tables = $filter('orderBy')(tables, 'entityName', false);
    forEach(tables, (table: any) => {
      entities.push(table.name);
    });
    scopeObj.securityProps.dbSchemas[selectedDatabase] = entities;
    scopeObj.security.entities = sort(entities);
    triggerFn(onSuccess);
  });
}

export function rootDn(domain: any) {
  let i = 0, rootDnArray, arrayLength, rootDnStr = '';
  rootDnArray = domain && domain.split('.');
  arrayLength = rootDnArray && rootDnArray.length;
  for (i = 0; i < arrayLength; i++) {
    if (arrayLength === i + 1) {
      rootDnStr += 'dc=' + rootDnArray[i];
    } else {
      rootDnStr += 'dc=' + rootDnArray[i] + ',';
    }
  }
  return rootDnStr;
}

export function openFile(path: any, fileName: any) {
  let identifier,
      wsType      = 'RESOURCE',
      details     = {
          name : fileName,
          type : 'file',
          path : path + fileName
      };
  identifier = wsType + ':' + details.path;
  // TODO
  // $rs.$emit('open-ws', wsType, fileName, identifier, details);
}

export function getPageObjectInMap(pageName: any, map: any) {
  let pageUrl = '/pages/' + pageName + '/**';
  return getObjectInMap(pageUrl, map);
}

export function getObjectInMap(url: any, map: any) {
  return find(map, { 'url': url});
}

export function setTableFields(projectId: any, dataModel: any, tableName: any, scopeObj: any, callback?: any) {
  scopeObj.securityProps.columnFieldMap = {};
  const dataModelDesignManager = AppInjector.get(DataModelDesignManagerService);

  dataModelDesignManager.getEntityForTable({
    projectId: projectId,
    dataModelName: dataModel,
    tableName: tableName
  }, (response: any) => {
    let tableFields: any = [];
    scopeObj.securityProps.tableEntityMap[response.name] = response.entityName;
    scopeObj.securityProps.relations = response.relations;
    response.columns.forEach((column: any) => {
      if (!column.hidden) {
        tableFields.push(column.name);
        scopeObj.securityProps.columnFieldMap[column.name] = column.fieldName; //Maintaining column to field name map
      }
    });
    scopeObj.securityProps.fieldColumnMap = invert(scopeObj.securityProps.columnFieldMap); //Maintaining field to column name map
    scopeObj.securityProps.dbSchemas[dataModel][tableName] = tableFields;
    scopeObj.security.tableFields = sort(tableFields);
    triggerFn(callback);
  });
}
